// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__eOAlq","title":"AfterBackImages_title__xqn0N","images":"AfterBackImages_images__ib5hI"};